import { Col, Row, Typography } from "antd";
import React from "react";

interface CountdownTimerProps {
  remainingTime: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ remainingTime }) => {
  const formatTime = (totalTimeInSeconds: number) => {
    const hours = Math.floor(totalTimeInSeconds / 3600);
    const minutes = Math.floor((totalTimeInSeconds % 3600) / 60);
    const seconds = totalTimeInSeconds % 60;
    return { hours, minutes, seconds };
  };

  const { hours, minutes, seconds } = formatTime(remainingTime);
  return (
    <div style={{ textAlign: "center" }}>
      <Row gutter={16} justify="center">
        <Col>
          <div style={timeBoxStyle}>
            <Typography.Title level={2} type="secondary">
              {hours}
            </Typography.Title>
            <Typography.Text type="secondary">Hours</Typography.Text>
          </div>
        </Col>
        <Col>
          <div style={timeBoxStyle}>
            <Typography.Title level={2} type="secondary">
              {minutes}
            </Typography.Title>
            <Typography.Text type="secondary">Minutes</Typography.Text>
          </div>
        </Col>
        <Col>
          <div style={timeBoxStyle}>
            <Typography.Title level={2} type="secondary">
              {seconds}
            </Typography.Title>
            <Typography.Text type="secondary">Seconds</Typography.Text>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const timeBoxStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  padding: "0px 10px 10px 10px",
  borderRadius: "5px",
  textAlign: "center",
  minWidth: "80px",
  border: "2px solid #d9d9d9", // Grey border
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Shadow effect
};

export default CountdownTimer;
